import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    connect: false,
    user: null,
    messages: [],
    queue: [],
    x: 0,
    y: 0,
    energy: 0,
    people: [],
    rooms: []
  },
  mutations: {
    SOCKET_connect: (state) => {
      console.log('connected') // eslint-disable-line no-console
      state.connect = true
    },
    SOCKET_disconnect: (state) => {
      console.log('disconnected') // eslint-disable-line no-console
      state.connect = false
      state.user = null
      state.messages = []
    },
    SOCKET_authenticated: (state, user) => {
      state.user = user
    },
    SOCKET_message: (state, message) => {
      state.messages.push(message)
    },
    SOCKET_map: (state, data) => {
      state.x = data.x
      state.y = data.y
      state.people = data.people
      state.rooms = data.rooms
    },
    SOCKET_queue: (state, queue) => {
      state.queue = queue
    },
    SOCKET_energy: (state, energy) => {
      state.energy = energy
    }
  },
  actions: {

  }
})
